import React, { FunctionComponent, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { stringToHsl } from '../../../../../../../../App/Util/stringToHsl'
import { IActivityCategory } from '../../../../../../interface/IActivity'
import { IMenuCategory } from '../../../../../../interface/IMenuCategory'
import {
    IActivitySelect,
    IFinalSelection,
} from '../../../../interfaces/IActivitySelect'
import { Tile } from '../Tile/Tile'

import { IProps } from './IProps'

export const ActivityCategorySelect: FunctionComponent<IProps> = ({
    activityList,
    activitySelectObject,
    setActivitySelectObject,
}) => {
    const [
        nextCategorySelection,
        setNextCategorySelection,
    ] = useState<IActivityCategory>()
    const { activeSelection } = activitySelectObject
    const { t } = useTranslation()

    const addSelectionId = (id: number) => {
        setActivitySelectObject({
            type: 'activity',
            activeSelection: [id],
            selectionDetails: null,
        })
        setNextCategorySelection(
            activityList.find((activity) => activity.id === id)
        )
        return
    }

    const addSelectionUuid = (uuidArray: IFinalSelection[]) => {
        setActivitySelectObject({
            type: 'selected',
            activeSelection,
            selectionDetails: uuidArray,
        })
        return
    }

    if (activeSelection.length === 0) {
        return (
            <>
                {activityList.map((extraActivity) => {
                    return (
                        <Tile
                            key={extraActivity.id}
                            tileTitle={t(`activities;;${extraActivity.name}`)}
                            tileColor={stringToHsl(extraActivity.name, 50, 50)}
                            onClick={() => addSelectionId(extraActivity.id)}
                        />
                    )
                })}
            </>
        )
    }

    return (
        <>
            {nextCategorySelection.activities.map((activity) => (
                <Tile
                    key={activity.id}
                    tileTitle={t(`activities;;${activity.name}`)}
                    tileColor={stringToHsl(activity.name, 50, 50)}
                    onClick={() => addSelectionUuid([{ uuid: activity.uuid, selectionDetails: { name: activity.name } }])}
                />
            ))}
        </>
    )
}
